import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { PSRevisionModel } from '../models/ps-revision';

@Injectable({
  providedIn: 'root'
})
export class PsRevisionService {

  myAppUrl: string;

  constructor(private _http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.myAppUrl = baseUrl;
  }

  get(idPs: number) {
    return this._http.get(`${ this.myAppUrl }api/PS_Revision/${idPs}`);
  }

  getViewModel(idPs: number) {
    return this._http.get(`${ this.myAppUrl }api/PS_Revision/GetViewModel/${idPs}`);
  }

  post(item: any) {
    return this._http.post<any>(`${ this.myAppUrl }api/PS_Revision`, item);
  }

}
